// src/services/accountService.ts
import api from './axios';

export const getAccountInfo = async () => {
	try {
		const response = await api.get('/account-info/account-info');
		if (response.status === 200) {
			return { success: true, message: 'Account info fetched successfully', data: response.data.accountInfo };
		}
		return { success: false, message: 'Failed to fetch account info', error: response.data.message };
	} catch (error) {
		throw error;
	}
};

export const updateAccountInfo = async (userData: any) => {
	try {
		const response = await api.put('/account-info/update-account-info', userData);
		if (response.status === 200) {
			return { success: true, message: 'Updated successfully', data: response.data.message };
		}
		return { success: false, message: 'Failed to update account info', error: response.data.message };
	} catch (error) {
		throw error;
	}
};